module.exports = __webpack_public_path__ + "static/media/F431312E-BC11-4D79-B4F5-9924D3E2614F.78ff0430.jpeg";